<template>
  <div class="advantage">
    <div class="header">
      <img src="../../assets/kh-007ab.jpg" alt="banner" class="banner">
      <div class="nav">
        <img src="../../assets/logo.png" alt class="logo">
        <router-link to="/" class="back">
          <span>返回主菜单</span>
          <img src="../../assets/back.png" alt="back">
        </router-link>
      </div>
    </div>
    <div class="body">
      <div class="body_title">
        <span class="body_title_name">合作优势</span>
        <router-link to="/contentUS" class="contentus">联系我们>></router-link>
      </div>
      <h3 class="h3">米仑的优势</h3>
      <ul class="body_content">
        <li>
          <img src="../../assets/blo.png" alt>
        </li>
        <li>
          <img src="../../assets/blo1.png" alt>
        </li>
        <li>
          <img src="../../assets/blo2.png" alt>
        </li>
        <li>
          <img src="../../assets/blo4.png" alt>
        </li>
        <li @click="openModal">
          <img src="../../assets/blo3.png" alt>
        </li>
      </ul>
    </div>
    <div class="main">
      <ul class="main_ul">
        <li>
          <!-- <h3 class='main_h3'>中国大陆客户分布图</h3> -->
          <img src="../../assets/blo8.jpg" alt>
        </li>
        <li>
          <!-- <h3 class='main_h3'>主要客户集团</h3> -->
          <img src="../../assets/blo5.png" alt>
        </li>
        <li>
          <h3 class="main_h3">企业成功的秘诀</h3>
          <div class="text">
            <p class="weight">在于对人才 / 产品 / 服务三项品质的坚持</p>
            <p>企业的竞争就是人才的竞争</p>
            <p>人才是最重要的资源</p>
            <p>规范运作 · 确保质量 · 信誉承诺</p>
            <p>服务是宗旨</p>
            <p>用户满意是企业永恒的追求</p>
          </div>
        </li>
      </ul>
      <div class="btn">
        <router-link to="/contentUS" class="content_btn">联系我们</router-link>
      </div>
    </div>
    <div class="modal-backdrop" v-show="showModal" @click="closeModal">
      <div class="modal" id="modal" v-show="showModal">
        <div class="modal-close" @click="closeModalCuspor">X</div>
        <div class="modal-body">
          <!-- 暂无代理证照片 -->
          <img :src="textInfo.show_image_address" alt>
        </div>
      </div>
    </div>
    <mb-fotter></mb-fotter>
    <div class="banner_img">
      <img src="../../assets/blo6.png" alt>
    </div>
    <div class="banner_img_1">
      <img src="../../assets/blo7.png" alt>
    </div>
  </div>
</template>

<script>
import mbFotter from "../../components/mb-fotter.vue";
import request from "../../server/request.js";

export default {
  data() {
    return {
      showCancle: false,
      confirmText: "知道了",
      showModal: false,
      textInfo: {}
    };
  },
  components: {
    mbFotter
  },

  created() {
    this.loadData();
  },
  methods: {
    confirm() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      const dom = document.getElementById("modal");
      if (dom) {
        if (!dom.contains(event.target)) {
          this.showModal = false;
        }
      }
    },
    closeModalCuspor() {
      this.showModal = false;
    },
    stop() {
      const mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    move() {
      const mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    loadData() {
      request.getShowImage(res => {
        this.textInfo = res.data.filter(
          item => item.show_image_location == "khk007a"
        )[0];
      });
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.stop();
      } else {
        this.move();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.advantage {
  position: relative;
  background: #fff9ed;
  height: 100%;
  .banner_img {
    position: absolute;
    right: 0;
    bottom: 140px;
    object-fit: contain;
  }
  .banner_img_1 {
    position: absolute;
    left: 0;
    bottom: 140px;
  }
  .header {
    .banner {
      width: 100%;
      // height: 12rem;
      background-size: 100% 100%;
    }
    .nav {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 0.26rem 1rem;
      .back {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-right: 5px;
        }
      }
    }
  }
  .body {
    margin-top: -1.2rem;
    width: 100%;
    .body_title {
      padding-left: 10%;
      .body_title_name {
        color: #fff;
        font-size: 0.88rem;
        letter-spacing: 2px;
        margin-right: 0.33rem;
        font-weight: 800;
      }
      .contentus {
        color: #fff;
        font-size: 0.68rem;
        letter-spacing: 2px;
        margin-right: 0.3rem;
        font-weight: 300;
      }
    }
    .h3 {
      text-align: center;
      letter-spacing: 2px;
      font-size: 0.94rem;
      // color: #fff;
      color: rgba(5, 65, 131, 1);
    }
    .body_content {
      display: flex;
      flex-wrap: wrap;
      margin-left: 11%;
      li {
        width: 15%;
        border-radius: 5px;
        margin-right: 0.8rem;
        img {
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }
    }
  }
  .main {
    margin-top: 1rem;
    position: relative;
    .main_ul {
      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 1.2rem;
        .main_h3 {
          width: 68%;
          padding: 0.38rem 0;
          border-top: 1px solid rgba(5, 65, 131);
          border-bottom: 1px solid rgba(5, 65, 131);
          font-size: 0.78rem;
          color: rgba(5, 65, 131, 1);
          text-align: center;
          font-weight: 800;
          margin-bottom: 0.6rem;
        }
        .text {
          width: 100%;
          p {
            text-align: center;
            color: #054183;
            font-size: 0.64rem;
            &.weight {
              font-weight: 800;
            }
          }
        }
      }
    }
    .btn {
      width: 100%;
      margin-bottom: 1rem;
      margin-top: 0.41rem;
      display: flex;
      justify-content: center;
      .content_btn {
        position: relative;
        z-index: 2;
        width: 6.76rem;
        height: 1.44rem;
        text-align: center;
        line-height: 1.44rem;
        border: 1px solid #ccc;
        background: #054183;
        color: #fff;
        font-weight: 500;
        font-size: 0.64rem;
        // letter-spacing: 2px;
        border-radius: 4px;
      }
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 15px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 9999;
    .modal {
      background: #fff;
      position: relative;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      width: 500px;
      .modal-close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        padding: 0;
        width: 48px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.45);
        text-decoration: none;
        font-size: 18px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: flex-start;
        padding: 0.3rem 0 0.3rem 0.6rem;
        display: flex;
        font-size: 0.32rem;
      }
      .modal-body {
        position: relative;
        padding: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .modal-footer {
        border-top: 1px solid #eee;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .btn-close,
        .btn-confirm {
          border-radius: 8px;
          border: none;
          cursor: pointer;
          font-size: 0.28rem;
          padding: 0.3rem 15px;
          outline: none;
          width: 100%;
        }
        .btn-close {
          color: #313131;
          background-color: transparent;
        }
        .btn-confirm {
          color: #000;
          /* background-color: #2d8cf0; */
          background-color: transparent;
        }
      }
    }
  }
  .animateame-enter-to,
  .animateame-leave-to {
    animation: move 1s ease-in-out;
  }
}

@keyframes move {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>